(()=>{
if(window.hushStudioPlayerLoaded)return;window.hushStudioPlayerLoaded=true;

function mount(root){
 if(root.dataset.studioReady)return;
 root.dataset.studioReady='true';const video=root.querySelector('video'),button=root.querySelector('button');
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 let visible=false,userPaused=false,userPlayed=false,disposed=false;
 video.muted=true;
 const update=()=>{button.setAttribute('aria-label',video.paused?'Play can animation':'Pause can animation');button.firstElementChild.textContent=video.paused?'\u25B6':'\u2161';root.dataset.motionPlaying=String(!video.paused);};
 const sync=()=>{
  if(disposed)return;
  const allowed=root.dataset.animate==='true'&&visible&&!document.hidden&&!userPaused&&((!reduced.matches&&!navigator.connection?.saveData)||userPlayed);
  if(allowed)video.play().catch(()=>update());else video.pause();update();
 };
 const observer=new IntersectionObserver(([entry])=>{visible=entry.isIntersecting;sync();},{threshold:.05});observer.observe(root);
 button.hidden=root.dataset.animate!=='true';
 button.addEventListener('click',(event)=>{event.stopPropagation();userPaused=!video.paused;userPlayed=!userPaused;sync();});
 video.addEventListener('play',update);video.addEventListener('pause',update);video.addEventListener('canplay',sync);
 document.addEventListener('visibilitychange',sync);reduced.addEventListener('change',sync);root.addEventListener('hush:motion-change',sync);
 const unload=(event)=>{if(!event.target.contains(root))return;disposed=true;video.pause();observer.disconnect();document.removeEventListener('visibilitychange',sync);reduced.removeEventListener('change',sync);root.removeEventListener('hush:motion-change',sync);document.removeEventListener('shopify:section:unload',unload);};
 document.addEventListener('shopify:section:unload',unload);sync();
}

const init=(scope=document)=>scope.querySelectorAll('[data-hush-studio]').forEach(mount);init();document.addEventListener('shopify:section:load',event=>init(event.target));
})();
